import { Heading, Typography } from '@/shared/ui';

import { getTimezoneOffset } from '../lib/format-utc';
import { getRelativeDayLabel } from '../lib/getRelativeDay';
import { IWorldTimeItem } from '../model/schemas';
import { useGetTime } from '../model/use-get-time';

export const WorldTimeItem = ({
  name,
  tzCode,
}: Omit<IWorldTimeItem, 'label' | 'utc'>) => {
  const { date } = useGetTime(tzCode);

  return (
    <div className="flex w-full items-start justify-between py-2">
      <div className="flex flex-col gap-y-1">
        <Typography variant="16-m-caps">{name}</Typography>

        <Typography
          variant="14-r"
          color="text-base-100"
          className="tracking-[0.3px]"
        >
          {getRelativeDayLabel(tzCode)}, {getTimezoneOffset(tzCode)}
        </Typography>
      </div>

      <Heading variant="s" tag="span">
        {date}
      </Heading>
    </div>
  );
};
